/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable prefer-smart-quotes/prefer */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable react/no-array-index-key */

"use client"

import algoliasearch from "algoliasearch/lite"
import Image from "next/image"
import {
  InstantSearch,
  useSearchBox,
  useHits,
  Highlight,
} from "react-instantsearch"
import "./search.css"
import { useRef, useEffect, useState } from "react"
import { useRouter } from "next/navigation"

import getContentTypePath from "@/helpers/getContentTypePath"

import {
  algoliaAppId,
  algoliaIndexName,
  algoliaRecommendedIndexName,
  algoliaSearchKey,
} from "../../../../environment"

import CustomSearchBox from "./CustomSearchBox"

// Initialize the Algolia search client
const searchClient = algoliasearch(algoliaAppId, algoliaSearchKey)

function Hit({
  item,
  isHighlighted,
  onClick,
  onMouseEnter,
  onMouseLeave,
  onFocus,
  innerRef,
  onKeyDown,
  isSearchResult,
  index,
}) {
  const HighlightComponent = Highlight as any

  return (
    <li
      id={`search-result-${index}`}
      role="option"
      aria-selected={isHighlighted}
      ref={innerRef}
      tabIndex={0}
      className={`w-full items-center gap-2 cursor-pointer pl-6 py-4 text-sm font-normal line-height-normal block ${
        isHighlighted ? "bg-gray-70" : ""
      } hover:bg-gray-80`}
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onFocus={onFocus}
      onKeyDown={onKeyDown}
    >
      {isSearchResult ? (
        <HighlightComponent
          attribute="fields.title.en-US"
          hit={item}
          highlightedTagName="span"
          classNames={{
            highlighted: "text-blue-30 font-extrabold",
            nonHighlighted: isHighlighted ? "text-white-100" : "text-gray-50",
          }}
        />
      ) : (
        <span className="text-white-100">{item.title}</span>
      )}
    </li>
  )
}

function SearchResults({ onClose, recommendedSearches, loading }) {
  const { query } = useSearchBox()
  const { hits } = useHits()
  const [selectedIndex, setSelectedIndex] = useState(-1)
  const router = useRouter()
  const itemRefs = useRef([])
  const listboxRef = useRef(null)

  // Combine hits and recommended searches based on the query
  const items = query ? hits : recommendedSearches
  const isSearchResult = !!query

  useEffect(() => {
    setSelectedIndex(-1)
  }, [query])

  function handleSelect(item) {
    if (!item) {
      console.error("Attempted to select an undefined item")
      return
    }

    if (isSearchResult) {
      if (!item.sys?.contentType?.sys?.id || !item.fields?.slug?.["en-US"]) {
        console.error(
          "Attempted to navigate to an incomplete search result item",
          item,
        )
        return
      }
      const contentType = item.sys.contentType.sys.id
      router.push(
        `${getContentTypePath(contentType)}${item.fields.slug["en-US"]}`,
      )
    } else {
      if (!item.url) {
        console.error(
          "Attempted to navigate to a recommended item without a URL",
          item,
        )
        return
      }
      router.push(`/${item.url}`)
    }
    onClose()
  }

  function handleKeyDown(event) {
    if (
      event.key === "Enter" &&
      selectedIndex >= 0 &&
      selectedIndex < items.length
    ) {
      handleSelect(items[selectedIndex])
    } else if (event.key === "Escape") {
      onClose()
    }
  }

  return (
    <div
      className="self-stretch overflow-auto max-h-full md:max-h-[268px] h-full bg-gray-90 rounded flex-col justify-start items-start flex"
      onKeyDown={handleKeyDown}
      ref={listboxRef}
      role="listbox"
      aria-activedescendant={
        selectedIndex >= 0 ? `search-result-${selectedIndex}` : undefined
      }
      tabIndex={0}
    >
      <p className="text-gray-50 caption2 pl-6 pt-6 pb-2">
        {isSearchResult ? "Matching Searches" : "Recommended Searches"}
      </p>

      {loading ? (
        // Loading Skeleton
        <ul className="w-full px-6 space-y-4 w-full mt-2">
          {Array.from({ length: 6 }).map((_, index) => (
            <li key={index} className="flex space-x-4 animate-pulse">
              <div className="flex-1 space-y-2 py-1">
                <div className="h-4 bg-gray-70 rounded w-2/4" />
              </div>
            </li>
          ))}
        </ul>
      ) : (
        // Search Results
        <ul className="w-full">
          {items.map((item, index) => (
            <Hit
              key={item.objectID || item.title}
              item={item}
              index={index}
              isHighlighted={index === selectedIndex}
              isSearchResult={isSearchResult}
              onClick={() => handleSelect(item)}
              onMouseEnter={() => setSelectedIndex(index)}
              onMouseLeave={() => setSelectedIndex(-1)}
              innerRef={(el) => {
                itemRefs.current[index] = el
              }}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  handleSelect(item)
                }
              }}
              onFocus={() => {
                setSelectedIndex(index)
                // Scroll the item into view when focused
                if (itemRefs.current[index]) {
                  itemRefs.current[index].scrollIntoView({
                    behavior: "smooth",
                    block: "nearest",
                    inline: "nearest",
                  })
                }
              }}
            />
          ))}
        </ul>
      )}
    </div>
  )
}
export default function SearchModal({ isOpen, onClose }) {
  const modalRef = useRef(null)
  const searchInputRef = useRef(null)
  const InstantSearchComponent = InstantSearch as any
  // Close modal on click outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose()
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [onClose])

  // Close modal on 'Escape' key
  useEffect(() => {
    function handleKeyDown(event) {
      if (event.key === "Escape") {
        onClose()
      }
    }

    window.addEventListener("keydown", handleKeyDown)
    return () => {
      window.removeEventListener("keydown", handleKeyDown)
    }
  }, [onClose])

  const [recommendedSearches, setRecommendedSearches] = useState([])
  const recommendedIndex = searchClient.initIndex(algoliaRecommendedIndexName)
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    async function fetchRecommendedSearches() {
      try {
        setLoading(true)
        const { hits } = await recommendedIndex.search("", {
          hitsPerPage: 6, // Adjust as needed
        })
        setRecommendedSearches(hits)
        setLoading(false)
      } catch (error) {
        console.error("Error fetching recommended searches:", error)
        setLoading(false)
      }
    }

    // Reset recommended searches when modal is closed
    if (!isOpen) {
      setRecommendedSearches([])
      return
    }

    // Only fetch if modal is open and we don't have recommendations yet
    if (isOpen && recommendedSearches.length === 0) {
      fetchRecommendedSearches()
    }
  }, [isOpen])

  // Focus ref callback for input
  const setInputRef = (element) => {
    searchInputRef.current = element
    if (element && isOpen) {
      element.focus()
    }
  }

  if (!isOpen) return null

  return (
    <div className="modal" role="searchbox" aria-label="searchbox">
      <div
        ref={modalRef}
        className=" w-full h-full md:w-[700px] md:h-[434px] px-4 py-6 bg-[#2e3438] rounded shadow flex-col justify-between md:justify-start items-start gap-4 inline-flex"
      >
        <InstantSearchComponent
          indexName={algoliaIndexName}
          searchClient={searchClient}
        >
          <div className="self-stretch justify-start items-start gap-4 inline-flex">
            <div className="flex-grow bg-[#14191e] rounded flex items-center">
              <CustomSearchBox
                inputRef={setInputRef}
                classNames={{
                  input:
                    "bg-[#14191e] text-white-100 text-base border-none font-normal font-[Work Sans] leading-normal ring-none tracking-tight focus:shadow-none focus:outline-none w-full pl-10 pr-4 py-2 rounded shadow-none outline-none",
                }}
              />
            </div>
          </div>
          {/* Display search results or recommended searches */}
          <SearchResults
            loading={loading}
            recommendedSearches={recommendedSearches}
            onClose={onClose}
          />
        </InstantSearchComponent>
        <button
          type="button"
          onClick={onClose}
          className="w-full border-solid border-[1.5px] border-blue-50 rounded-[40px] bg-gray-80 text-center h-[52px] p-4 shadow justify-start items-center gap-4 md:hidden block leading-none"
        >
          Cancel
        </button>
        <div className="w-full h-[52px] p-4 bg-[#14191e] rounded-bl rounded-br shadow justify-start items-center gap-4 hidden md:inline-flex">
          <div className="justify-start items-center gap-2 flex">
            <Image alt="tab-key" height={15} width={26} src="/icons/Tab.png" />
            <div className="text-white text-sm font-['TT Ripple'] leading-tight">
              to navigate
            </div>
          </div>
          <div className="justify-start items-center gap-2 flex">
            <Image height={15} width={15} src="/icons/enter.png" alt="enter" />
            <div className="text-white text-sm font-['TT Ripple'] leading-tight">
              to select
            </div>
          </div>
          <div className="justify-start items-center gap-2 flex">
            <Image
              alt="escape key"
              height={15}
              width={26}
              src="/icons/esc.png"
            />
            <div className="text-white text-sm font-['TT Ripple'] leading-tight">
              to close
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
